<template>
  <vue3-html2pdf
    ref="html2Pdf"
    :show-layout="false"
    :float-layout="true"
    :enable-download="true"
    :preview-modal="false"
    :filename="filename"
    :pdf-quality="2"
    :manual-pagination="manualPagination"
    :paginate-elements-by-height="700"
    pdf-format="letter"
    pdf-orientation="landscape"
    pdf-content-width="1050px"
    @before-download="beforeDownload($event)"
    @has-downloaded="hasDownloaded()"
  >
    <template #pdf-content>
      <slot />
    </template>
  </vue3-html2pdf>
</template>

<script>
import Vue3Html2pdf from 'vue3-html2pdf'

export default {
  components: {
    Vue3Html2pdf,
  },
  props: {
    filename: {
      type: String,
      default: 'filename',
    },
    manualPagination: {
      type: Boolean,
      default: true,
    },
    paginate: {
      type:Boolean,
      default: false,
    },
    margin:{
      type: [Number, String, Array],
      default: 0,
    },
  },
  mounted() {
    setTimeout(() => {
      this.download()
    }, 200)
  },
  methods: {
    download () {
      this.$refs.html2Pdf.downloadPdf()
    },
    hasDownloaded() {
      setTimeout(() => {
        window.close()
      }, 150)
    },
    async beforeDownload ({ html2pdf, options, pdfContent }) {
      options.pagebreak =  {mode: ['css', 'legacy']}
      options.margin = this.margin

      await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
        if (this.paginate) {
          const totalPages = pdf.internal.getNumberOfPages()
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i)
            pdf.setFontSize(10)
            pdf.setTextColor(150)
            pdf.text(i + '/' + totalPages, (pdf.internal.pageSize.getWidth() * 0.93), (pdf.internal.pageSize.getHeight() - 0.2))
          }
        }
      }).save()
    },
  },
}
</script>
